module.exports = __webpack_public_path__ + "static/media/coo_image.51d3f1ff.png";